export enum ORDER_FILTERED_FIELD_OPTIONS_ENUM {
  ORDER_NUMBER = 'orderNumber',
  FINAL_CUSTOMER_DOCUMENT = 'finalCustomerDocument',
  FINAL_CUSTOMER_NAME = 'finalCustomerName',
}

export enum ORDER_STATUS_ENUM {
  PROCESSING = 1,
  PROCESSED = 2,
  INVOICED = 3,
  PARTIALLY_INVOICED = 4,
  SHIPPED = 5,
  PARTIALLY_SHIPPED = 6,
  DELIVERED = 7,
  PARTIALLY_DELIVERED = 8,
  CANCELED = 9,
  PARTIALLY_CANCELED = 10,
  DELAYED = 11,
  PARTIALLY_DELAYED = 12,
  PAID = 13,
  PARTIALLY_PAID = 14,
  TRANSFERRED = 999,
}

export enum ORDER_PRODUCT_TYPE_ENUM {
  HARDWARE = 1,
  SOFTWARE_AND_SERVICE = 2,
  CLOUD_SERVICE = 3,
}
